import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import './i18n'; // initialize i18next before rendering
import AppRouter from './AppRouter';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root') as HTMLElement;

if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <React.StrictMode>
      <AppRouter />
    </React.StrictMode>
  );
} else {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <AppRouter />
    </React.StrictMode>
  );
}

reportWebVitals((metric) => {
  // Ejemplo: enviar a Google Analytics 4 vía gtag si está disponible
  if ((window as any).gtag) {
    (window as any).gtag('event', metric.name, {
      value: metric.value,
      event_category: 'Web Vitals',
      event_label: metric.id,
      non_interaction: true,
    });
  }

  // Ejemplo alternativo: enviar a un endpoint propio
  // navigator.sendBeacon('/api/web-vitals', JSON.stringify(metric));
});
